import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeRepairReportDetail } from './normalizeRepairReportDetail';
import { serializeRepairReportComplete } from './serialize';

/**
 * 完成維修報告：DRAFT → COMPLETED。
 * POST `/aftersales/repair-report/{id}/complete`。
 * body 僅 `{ updatedAt }`。
 *
 * @param {string} id
 * @param {{ updatedAt?: string, record?: { updatedAt?: string } }} [payload]
 */
export async function completeRepairReport(id, payload = {}) {
  const { data: raw } = await request.post(
    `/aftersales/repair-report/${id}/complete`,
    serializeRepairReportComplete(payload),
  );
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeRepairReportDetail(parsed.data),
  };
}
